"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineClaimResponse = void 0;
class OnlineClaimResponse {
}
exports.OnlineClaimResponse = OnlineClaimResponse;
//# sourceMappingURL=OnlineClaimResponse.js.map